import { useMutation } from '@tanstack/react-query';
import type { MFAIdentityType } from '@/entities/mfa-identity';
import type { EnableTwoFactorIdentityRequestDto } from '../types';
import { enableTwoFactorIdentity } from '../requests';

const useTwoFactorEnable = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => {
  const mutation = useMutation({
    mutationFn: ({
      identityType,
      data,
    }: {
      identityType: MFAIdentityType;
      data: EnableTwoFactorIdentityRequestDto;
    }) => {
      return enableTwoFactorIdentity(identityType, data);
    },
    onSuccess,
    onError,
  });

  return {
    enableTwoFactor: mutation.mutateAsync,
    isEnableTwoFactorLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isEnableTwoFactorError: mutation.isError,
    enableTwoFactorError: mutation.error,
    resetEnableTwoFactor: mutation.reset,
    mutation,
  };
};

export { useTwoFactorEnable };
